import { render, staticRenderFns } from "./PanelDeactivated.vue?vue&type=template&id=bdf9220a&scoped=true&"
import script from "./PanelDeactivated.vue?vue&type=script&lang=js&"
export * from "./PanelDeactivated.vue?vue&type=script&lang=js&"
import style0 from "./PanelDeactivated.vue?vue&type=style&index=0&id=bdf9220a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf9220a",
  null
  
)

export default component.exports